// Height of the sticky header, change this if the height of the sticky header changes
export const STICKY_HEADER_HEIGHT = 60

// Height of the mini header added by the updated_pull_request_header flag
export const MINI_HEADER_HEIGHT = 48

// Margin top space to give a diff entry when scrolling
export const BASE_DIFF_MARGIN_TOP_PADDING = 10

// DOM id of the Overview merge box wrapper, used as a scroll anchor from other
// overview items (e.g. the For You "Merge is blocked" action).
export const OVERVIEW_MERGE_BOX_ANCHOR_ID = 'overview-merge-box'

export const STACKS_FEEDBACK_SUBJECT = 'stacks-feedback'
